import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import MuIconButton from '@mui/material/IconButton';

const IconButton = React.forwardRef(({ children, color, loading, disabled,  ...props }, ref) => (
  <MuIconButton
    color={color}
    disabled={disabled || loading}
    ref={ref}
    {...props}
  >
    { loading ? <CircularProgress size={20}/> : children }
  </MuIconButton>
));



IconButton.propTypes = {
  disabled: PropTypes.bool,
  color: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired
};

IconButton.defaultProps = {
  loading: false,
  disabled: false,
  color: 'primary',
};

export default IconButton;
